(() => {
  const params = new URLSearchParams(window.location.search);
  const content = params.get('utm_content') || '';
  const requested = params.get('message');
  const mode = requested === 'taste' || /taste[ _-]*static/i.test(content) ? 'taste'
    : requested === 'proof' || /social[ _-]*proof/i.test(content) ? 'proof' : null;
  if (!mode) return;
  const headline = mode === 'taste' ? 'Yerba mate that actually tastes good.' : 'See what Steep drinkers are saying.';
  const apply = () => {
    const node = document.querySelector('#steep-trial-hero-title, #steep-b-2-hero-title, #steep-b-4-hero-title, [data-steep-mobile-headline]');
    if (!node || /3 Cans/i.test(node.textContent)) return false;
    node.textContent = headline;
    node.dataset.steepMessageMatch = mode;
    return true;
  };
  if (!apply()) {
    const observer = new MutationObserver(() => { if (apply()) observer.disconnect(); });
    observer.observe(document.body, {childList:true,subtree:true});
    setTimeout(() => observer.disconnect(), 10000);
  }
})();
